import axios from 'axios';

import ServiciosEditar from '../types/ServiciosEditar';


async function GuardarServicio(prmServicio: ServiciosEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_servicio"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "servicio": {
                "id": prmServicio.id,
                "nombre": prmServicio.nombre,
                "descripcion": prmServicio.descripcion,
                "habilitado": prmServicio.habilitado,
                "mostrar_web": prmServicio.mostrar_web,
                "fch_modi": prmServicio.fecha_modificacion,
                "dado_de_baja": prmServicio.dado_de_baja,
                "fch_baja": prmServicio.fecha_baja,
                "logo_mime": prmServicio.logo_mime,
                "logo_content": prmServicio.logo_content,
                "logo_name": prmServicio.logo_name
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarServicio;